import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling-light';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "AccountSourceList" */ './lazyIndex'),
    { name: 'AccountSourceList' }
);

export const lazyAccountSourceListPostRender: LazyAction<
    typeof lazyIndex.accountSourceListPostRender,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.accountSourceListPostRender);

export const lazyEnsureAllAdditionalAccountInfoData: LazyAction<
    typeof lazyIndex.ensureAllAdditionalAccountInfoData,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.ensureAllAdditionalAccountInfoData);

export const lazyEnsureSharedMailboxData: LazyAction<
    typeof lazyIndex.ensureSharedMailboxData,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.ensureSharedMailboxData);

export const lazyEnsureSharedMailboxDataForMailboxInfo: LazyAction<
    typeof lazyIndex.ensureSharedMailboxDataForMailboxInfo,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.ensureSharedMailboxDataForMailboxInfo);

export const lazyEnsurePreRenderForAccount: LazyAction<
    typeof lazyIndex.ensurePreRenderForAccount,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.ensurePreRenderForAccount);

export const lazyOobeInitForNewlyAddedGlobalSettingsAccount: LazyAction<
    typeof lazyIndex.oobeInitForNewlyAddedGlobalSettingsAccount,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.oobeInitForNewlyAddedGlobalSettingsAccount);

export const lazyRetryPreRenderForAccount: LazyAction<
    typeof lazyIndex.retryPreRenderForAccount,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.retryPreRenderForAccount);

export const lazyAreNewAccountAndExistingAccountsMutuallyCompliant: LazyAction<
    typeof lazyIndex.areNewAccountAndExistingAccountsMutuallyCompliant,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.areNewAccountAndExistingAccountsMutuallyCompliant);

export const lazyUpdateAccountStateBasedOnPolicy: LazyAction<
    typeof lazyIndex.updateAccountStateBasedOnPolicy,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.updateAccountStateBasedOnPolicy);

export const lazyUpdateLicensingIdentitiesStateBasedOnAccountPolicy: LazyAction<
    typeof lazyIndex.updateLicensingIdentitiesStateBasedOnAccountPolicy,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.updateLicensingIdentitiesStateBasedOnAccountPolicy);

export const lazyGetNonOfficeProPlusAccounts: LazyAction<
    typeof lazyIndex.getNonOfficeProPlusAccounts,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getNonOfficeProPlusAccounts);

export const lazyIsLastLicenseCompliantMailboxInfo: LazyAction<
    typeof lazyIndex.isLastLicenseCompliantMailboxInfo,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.isLastLicenseCompliantMailboxInfo);

export const lazyIsLicenseRequirementsCompliant: LazyAction<
    typeof lazyIndex.isLicenseRequirementsCompliant,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.isLicenseRequirementsCompliant);

export const lazyAreAllAccountsPolicyAllowingConsumerAccounts: LazyAction<
    typeof lazyIndex.areAllAccountsPolicyAllowingConsumerAccounts,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.areAllAccountsPolicyAllowingConsumerAccounts);

export const lazyBuildMailboxContracts: LazyAction<
    typeof lazyIndex.buildMailboxContracts,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.buildMailboxContracts);
